export default class RandomValuePool
{
    constructor(values)
    {
        this.pool;
        this.values = JSON.parse(JSON.stringify(values));
        this.restart();
    }

    restart() {
        this.pool = JSON.parse(JSON.stringify(this.values));
        Phaser.Utils.Array.Shuffle(this.pool)
    };

    getValue() {
        if (this.pool.length <= 0) {
            this.restart();
        }
        return this.pool.pop();
    };
}